import { useAtom } from 'jotai';
import { cookieBannerAcceptedAtom } from '@/global-store';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Link,
} from '@eye-able/ui';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { T } from '@/i18n/T';

const PrivacyDialog = () => {
  const { t } = useInlineTranslation();
  const [accepted, setAccepted] = useAtom(cookieBannerAcceptedAtom);

  const handleConfirm = () => {
    setAccepted(true);
  };

  return (
    <Dialog open={!accepted}>
      <DialogContent
        persistent
        // Keeps the cookie consent dialog above react-joyride's product
        // tour overlay (options.zIndex: 9000 in UserTour.jsx).
        overlayClassName='eye:z-[9500]'
      >
        <DialogTitle className='eye:sr-only'>
          <T k='privacyDialogTitle' />
        </DialogTitle>
        <DialogDescription>
          <div className='eye:flex eye:flex-col eye:gap-2xs'>
            <p>
              <T k='privacyDialogDesc' />
            </p>
            <p>
              <T k='privacyDialogMore' />{' '}
              <Link href='/privacy-policy' target='_blank' size='small'>
                {t('privacyPolicy')}
              </Link>
              .
            </p>
          </div>
        </DialogDescription>
        <DialogActions>
          <Button variant='yellow' onClick={handleConfirm}>
            {t('accept')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyDialog;
